<template>
  <span>
    <span class="fs-14">{{canShowEmail?email:'S.O.'}}</span>
    <el-link :underline="false" type="primary" class="ml-5" v-if="mailTo && canShowEmail" :href="'mailto:' + email"><i class="mdi mdi-email"/></el-link>
  </span>
</template>
<script>
export default {
	name: 'Email',
  props: {
    email : {validator: prop => typeof prop === 'string' || prop == null , required:true},
    mailTo : {type : Boolean, default :true}
	},
  data() {
    return {

    };
  },
  methods : {

  },
	computed : {
    canShowEmail(){
      return this.email!=null && this.email!='';
    }
	},
  mounted(){

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>


</style>
